
export class ConnectionStatusEvent
{
    constructor(
        public IsConnected: boolean,
        public NoConnectionReason?: string)
    { }

    public get IsNotConnected(): boolean
    {
        return !this.IsConnected;
    }
}
